function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6fdbbc9d-c36e-4449-a570-473950d38ed1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m26.866,6.649h-11.537c-.828,0-1.5-.671-1.5-1.5s.672-1.5,1.5-1.5h11.537c.828,0,1.5.671,1.5,1.5s-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.866,17.5H5.134c-.828,0-1.5-.671-1.5-1.5s.672-1.5,1.5-1.5h21.731c.828,0,1.5.671,1.5,1.5s-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.275 11.478 12.685 3.851 3.866 3.851 8.275 11.478",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.866,28.351H5.134c-.828,0-1.5-.671-1.5-1.5s.672-1.5,1.5-1.5h21.731c.828,0,1.5.671,1.5,1.5s-.672,1.5-1.5,1.5Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDown);
export default __webpack_public_path__ + "static/media/MenuDown.3bfab5ca5d7ed6f8243a9ad499ccf4b8.svg";
export { ForwardRef as ReactComponent };